import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FC, Fragment, useCallback, useEffect, useState } from 'react';
//components
import EditSyrupBaseIngredientForm from 'components/main/SyrupBaseIngredients/Edit/EditSyrupBaseIngredientForm';
//constants, interfaces, graphql
import { ParamType } from 'interfaces';
import { EDIT_SYRUP_BASE_INGREDIENT_TEXT, HTTP_STATUS } from 'constants/index';
//styles
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { IngredientPayload, useGetSyrupBaseIngredientLazyQuery } from 'generated/graphql';

const EditSyrupBaseIngredient: FC = () => {
  const { id } = useParams<ParamType>();
  const [ingredient, setIngredient] = useState<IngredientPayload['ingredient']>(null);

  const [getIngredient, { loading }] = useGetSyrupBaseIngredientLazyQuery({
    onCompleted: (data) => {
      const { getIngredient } = data || {};
      const { response, ingredient } = getIngredient || {};
      const { status } = response || {};
      if (status === HTTP_STATUS.SUCCESS) {
        setIngredient(ingredient as IngredientPayload['ingredient']);
      }
    },
    onError: () => {
      setIngredient(null);
    },
  });

  const fetchIngredient = useCallback(async () => {
    await getIngredient({
      variables: {
        getIngredientInput: { id: id ?? '' },
      },
    });
  }, [getIngredient, id]);

  useEffect(() => {
    id && fetchIngredient();
  }, [fetchIngredient, id]);

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{EDIT_SYRUP_BASE_INGREDIENT_TEXT}</Typography>
      </Box>

      <EditSyrupBaseIngredientForm
        loading={loading}
        ingredient={ingredient}
        fetchIngredient={fetchIngredient}
      />
    </Fragment>
  );
};

export default EditSyrupBaseIngredient;
